import React, { useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  CCol,
  CRow,
} from '@coreui/react';
import { RootState } from '../../store/state';
import { UserInfo } from '../../shared/models/user';
import { selectUserProfile } from '../../store/selectors/profile.selectors';
import { SyncSubscriptionStatus } from '../../store/actions/billing.action';
import LoadingButton from '../../shared/components/LoadingButton';
import chargebeeCheckoutHandler from '../../shared/utils/chargebee-utils';
import { LoadOrg } from '../../store/actions/orgHierarchy.action';

interface SubscribePageProps {
  user: UserInfo;
}

const SubscribePage = ({ user }: SubscribePageProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const profile = useSelector(selectUserProfile);
  const isSucceededRef = useRef(false);

  const successCallback = (hostedPageId) => {
    isSucceededRef.current = true;
    dispatch(new SyncSubscriptionStatus(hostedPageId));
  };

  const closeCallback = () => {
    if (isSucceededRef.current) {
      dispatch(new LoadOrg(user.orgId));
      history.push('/dashboard');
    }
  };

  return (
    <CRow>
      <CCol className="flex-column flex-center">
        <h1 className="text-center">Setup your subscription</h1>
        <p className="text-center">As a next step, you will need to enter your billing details. Don’t worry, you won’t be charged until the end of your 30-day free trial period is over.</p>
        <p className="text-center">And remember, you can cancel your Glympse PRO subscription anytime.</p>
        <LoadingButton
          size="lg"
          className="bg-color-orange border-0"
          onClick={() => chargebeeCheckoutHandler(profile, successCallback, closeCallback)}
          isLoading={false}
        >
          Setup Billing Information
        </LoadingButton>
      </CCol>
    </CRow>
  );
}

const mapStateToProps = (state: RootState) => ({
  user: state?.profile?.userInfo,
});

export default connect(mapStateToProps)(SubscribePage);
